import { Search, X } from 'lucide-react';
import { ACTIVATION } from './shared';

const sel = 'h-9 rounded-lg border border-slate-200 bg-white px-2.5 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-teal-400';

const Select = ({ value, onChange, label, options, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={sel} data-testid={testId} aria-label={label}>
    <option value="">{label}</option>
    {options.map((o) => (Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>))}
  </select>
);

const DateRange = ({ label, from, to, onFrom, onTo, testId }) => (
  <div className="flex items-center gap-1.5 text-xs text-slate-500">
    <span className="whitespace-nowrap">{label}</span>
    <input type="date" value={from} onChange={(e) => onFrom(e.target.value)} className={sel} data-testid={`${testId}-from`} />
    <span>–</span>
    <input type="date" value={to} onChange={(e) => onTo(e.target.value)} className={sel} data-testid={`${testId}-to`} />
  </div>
);

export const EngagementFilters = ({ f, set, facets, statuses, onReset }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-4 space-y-3" data-testid="engagement-filters">
    <div className="flex flex-wrap gap-2 items-center">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input value={f.search} onChange={(e) => set('search', e.target.value)} placeholder="Search name, email or mobile"
          className={`${sel} w-full pl-9`} data-testid="engagement-search-input" />
      </div>
      <Select value={f.assessment} onChange={(v) => set('assessment', v)} label="Assessment: all" testId="filter-assessment"
        options={[['not_started', 'Not started'], ['in_progress', 'In progress'], ['completed', 'Completed']]} />
      <Select value={f.status} onChange={(v) => set('status', v)} label="Follow-up: all" options={statuses} testId="filter-status" />
      <Select value={f.assigned} onChange={(v) => set('assigned', v)} label="Assigned: all" options={['Unassigned', ...new Set([...(facets.team || []), ...facets.assignees])]} testId="filter-assigned" />
      <Select value={f.referral} onChange={(v) => set('referral', v)} label="Referred by: all" options={[['DIRECT', 'Direct / no referral'], ...(facets.referrals || [])]} testId="filter-referral" />
      <Select value={f.source} onChange={(v) => set('source', v)} label="Source: all" options={facets.sources} testId="filter-source" />
      <Select value={f.college} onChange={(v) => set('college', v)} label="College: all" options={facets.colleges} testId="filter-college" />
      <Select value={f.activation_status} onChange={(v) => set('activation_status', v)} label="Activation: all" testId="filter-activation"
        options={Object.entries(ACTIVATION).map(([k, [l]]) => [k, l])} />
    </div>
    <div className="flex flex-wrap gap-4 items-center">
      <DateRange label="Registered" from={f.reg_from} to={f.reg_to} onFrom={(v) => set('reg_from', v)} onTo={(v) => set('reg_to', v)} testId="filter-registered" />
      <DateRange label="Last contacted" from={f.contact_from} to={f.contact_to} onFrom={(v) => set('contact_from', v)} onTo={(v) => set('contact_to', v)} testId="filter-contacted" />
      <button type="button" onClick={onReset} className="ml-auto inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800" data-testid="engagement-reset-filters">
        <X className="w-4 h-4" /> Reset
      </button>
    </div>
  </div>
);
